import { render } from "./MdDialogPrompt.vue?vue&type=template&id=1f30e24a"
import script from "./MdDialogPrompt.vue?vue&type=script&lang=js"
export * from "./MdDialogPrompt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__